// One network fetch per URL per page, shared by every reader: lifts.json and
// livery.json feed both the Funicular and the Aerialway, water.json both the
// lake sheets (sky.js) and the swim index (water.js loadWater). Through the
// asset queue (assetq.js) as class `bulk` (location-independent phase-1 data).
// Each used to fetch its own copy. The TEXT is shared, never a parsed
// object — every reader parses its own, so one that mutates its document
// cannot reach into another's. Same contract as the inline
// `fetch(u).then((r) => (r.ok ? r.json() : null))` it replaces: null on a
// non-2xx, a rejection on a network or parse error. A rejected fetch is
// forgotten, so a later reader asks again. A big text is parsed in steps
// (assetq.js parseJsonBody).
import { fetchAsset, parseJsonBody } from './assetq.js';
import { actLabel } from './sched.js';

const _text = new Map();

export function fetchJsonOnce(url) {
  let p = _text.get(url);
  if (!p) {
    p = fetchAsset(url, { prio: 'bulk', as: 'text' });
    p.catch(() => { if (_text.get(url) === p) _text.delete(url); });
    _text.set(url, p);
  }
  return p.then((t) => (t === null ? null : parseJsonBody(t, actLabel('parse', url))));
}
